import { Color, Status } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';
import { isEnumValid, isValidWidth } from '@philips-emr/tws-utils';

import { StampIcon } from '../../constants';

import { CardMode, CardType } from './constants';

class AvatarCardAPI extends ComponentAPI implements Clickable {

  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  getType(): CardType {
    return this.state.type;
  }

  setType(type: CardType): void {
    if (!isEnumValid(CardType, type)) return;

    this.setState({ type });
  }

  getTitle(): string {
    return this.state.title;
  }

  setTitle(title: string): void {
    this.setState({ title });
  }

  getSubtitle(): string {
    return this.state.subtitle;
  }

  setSubtitle(subtitle: string): void {
    this.setState({ subtitle });
  }

  isSubtitlesHiddenOnMobile(): boolean {
    return this.state.subtitleHiddenOnMobile;
  }

  setSubtitlesHiddenOnMobile(subtitleHiddenOnMobile: boolean): void {
    this.setState({ subtitleHiddenOnMobile });
  }

  getImage(): string {
    return this.state.image;
  }

  setImage(image: string): void {
    this.setState({ image });
  }

  getStatus(): Status {
    return this.state.status;
  }

  setStatus(status: Status): void {
    if (!isEnumValid(Status, status)) return;

    this.setState({ status });
  }

  getStampLabel(): string {
    return this.state.stampLabel;
  }

  setStampLabel(stampLabel: string): void {
    this.setState({ stampLabel });
  }

  getStampIcon(): StampIcon {
    return this.state.stampIcon;
  }

  setStampIcon(stampIcon: StampIcon): void {
    this.setState({ stampIcon });
  }

  isStampVisible(): boolean {
    return this.state.stampVisible;
  }

  setStampVisible(stampVisible: boolean): void {
    this.setState({ stampVisible });
  }

  getColor(): Color {
    return this.state.color;
  }

  setColor(color: Color): void {
    if (!isEnumValid(Color, color)) return;

    this.setState({ color });
  }

  isDateVisible(): boolean {
    return this.state.dateVisible;
  }

  setDateVisible(dateVisible: boolean): void {
    this.setState({ dateVisible });
  }

  getMode(): CardMode {
    return this.state.mode;
  }

  setMode(mode: CardMode): void {
    if (!isEnumValid(CardMode, mode)) return;

    this.setState({ mode });
  }

  getWidth(): number {
    return this.state.width;
  }

  setWidth(width: number): void {
    if (isValidWidth(width)) {
      this.setState({ width });
    }
  }
}

export default AvatarCardAPI;
